import React from 'react';
import { Fade } from "react-awesome-reveal";
import check from '../../images/icon/check.svg'
import error from '../../images/icon/erorr.svg'
import logo from '../../images/logo/main.png'
import star from '../../images/icon/star.svg'

const FeaturesSection = (props) => {

    return (
        <section className="feature">
            <div className="feature-wrapper sec-bg sec-bg--2 pt-130 pb-130">
                <div className="container">
                    <div className="feature_inner">
                        <div className="sec-title--two text-center mb-60">
                            <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                                <div>
                                    <div className="sub-title wow fadeInDown" data-wow-duration="600ms"><img
                                        src={star} alt="" />Why choose us</div>
                                </div>
                            </Fade>
                            <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                                <div>
                                    <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Take a
                                        look at how we're different</h2>
                                </div>
                            </Fade>
                        </div>
                        <table className="feature-table">
                            <thead>
                                <tr>
                                    <th>Services</th>
                                    <th><img src={logo} alt="" /></th>
                                    <th>Other Providers</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                <tr>
                                    <td>Complete Odoo Integration & Setup</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={error} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>Shopify Integration & Management</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={error} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>Magento Development & Customization</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={error} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>Custom App Development Solutions</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={check} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>E-commerce Platform Optimization</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={error} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>Inventory & Order Management Automation</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={error} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>Multi-platform Integration Services</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={check} alt="" /></td>
                                </tr>
                                <tr>
                                    <td>Dedicated Support & Maintenance</td>
                                    <td><img src={check} alt="" /></td>
                                    <td><img src={check} alt="" /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;